import slice from "./areaHealthSlice";

export default slice.reducer;
